import customAxios from './axios';
import { ASN_V1 } from "../constants/api";

export function createAsn({data}) {
    return customAxios.post(ASN_V1, data);
}

export function getDeliveryMethods() {
    return customAxios.get(ASN_V1 + '/delivery-methods');
}